export const COMPANY_GET_ALL = "V1_COMPANY_GET_ALL";
export const GET_COMPANY_THRU_COID = "V1_GET_COMPANY_THRU_COID";
export const CREATE_COMPANY = "V1_CREATE_COMPANY";
export const UPDATE_COMPANY = "V1_UPDATE_COMPANY";
export const UPDATE_REMARKCOUNT_COMPANY = "V1_UPDATE_REMARKCOUNT_COMPANY";
